import React, { Component } from 'react';
class DynamicComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        return (
            <div style={{ marginLeft: "200px", padding:'10px' }}>
                {this.props.selectedComponent}
            </div>
        )
    }

}

export default DynamicComponent;